import { useState, useEffect } from "react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../App/store"
import "../../../Styles/main.scss"
import { setModalData } from "../SharedSlices/ModalSlice"
import HeaderMenuItem from "./HeaderMenuItem"
import { useLocation, useNavigate, useParams } from "react-router"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import Image from "../Primitive/Image"
import Card from "../Primitive/Card"
import { logOut } from "../../User/UserDashboard/Logout"
import { profileDefault, organizationProfileDefault } from "../../../App/GlobaleVariables"
import { RoleType, StorageKey, SubscriptionType } from "../../../App/enums"
import { getUserProfileSettingsState } from "../../User/UserSettings/UserSettingsSlice"
import { GreyVectorDown } from "../Components/SvgIcons"
import TutorialBubble from "../Components/TutorialBubble"
import HTTPService from "../../../App/HTTPService"
import { headers } from "../../../App/Axios"
import SessionService from "../../../App/SessionService"

function HeaderProfileMenu() {
    const { id } = useParams()
    let navigate = useNavigate()
    const location = useLocation()
    const userDataState = useSelector((state: RootState) => state.userDataSlice)
    const organizationDataState = useSelector((state: RootState) => state.organizationsSlice.organizationSlice.organization)
    const translation = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    let profieMenuRef = React.useRef<HTMLInputElement>(null)
    const [profileMenuOpen, setProfileMenuOpen] = useState(false)
    const profileImage =
        role === RoleType.USER ? userDataState.profile_photo?.url_path || profileDefault : organizationDataState.photo?.url_path || organizationProfileDefault

    const onUserSettingsModalOpen = () => {
        dispatch(setModalData({ open: true, settings: true }))
        dispatch(getUserProfileSettingsState({ status: true, isHashtag: false }))
    }

    const onOrganizationSettingsModalOpen = () => {
        setProfileMenuOpen(false)
        dispatch(setModalData({ open: true, organizationSettings: true }))
    }

    const onManageAdmins = () => {
        setProfileMenuOpen(false)
        const orgId = id || organizationDataState?.id || SessionService.getItem(StorageKey.organizationId)
        if (!orgId) return
        const profilePath = `/organization-profile/${orgId}`
        if (location.pathname === profilePath) {
            dispatch(setModalData({ open: true, addAdminModal: true }))
        } else {
            navigate(profilePath)
            window.setTimeout(() => {
                dispatch(setModalData({ open: true, addAdminModal: true }))
            }, 220)
        }
    }

    const onCreateRoom = () => {
        setProfileMenuOpen(false)
        const orgId = id || organizationDataState?.id || SessionService.getItem(StorageKey.organizationId)
        if (orgId) {
            HTTPService.get(`/org/${orgId}/room-limit/`, headers)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(setModalData({ open: true, createRoom: true }))
                    }
                })
                .catch(error => {
                    if (error.response?.status === 400) {
                        dispatch(
                            setModalData({
                                open: true,
                                roomLimitModal: { status: true, max_rooms: error.response.data.max_rooms },
                            })
                        )
                    } else {
                        dispatch(setModalData({ open: true, createRoom: true }))
                    }
                })
        } else {
            dispatch(setModalData({ open: true, createRoom: true }))
        }
    }

    const onAddOrganizationModalOpen = () => {
        dispatch(setModalData({ open: true, addOrganization: true }))
    }

    useEffect(() => {
        const onMouseDownHandler = (event: Event) => {
            const eventTarget = event.target as HTMLElement

            // Keep header menus stable while interacting with the tutorial overlay.
            if (
                eventTarget?.closest(".speechbubble") ||
                eventTarget?.closest(".speechbubble__backdrop") ||
                eventTarget?.closest(".speechbubble__spotlight")
            ) {
                return
            }

            if (profileMenuOpen && profieMenuRef.current && !profieMenuRef.current.contains(eventTarget)) {
                setProfileMenuOpen(false)
            }
        }
        document.addEventListener("mousedown", onMouseDownHandler)

        return () => {
            document.removeEventListener("mousedown", onMouseDownHandler)
        }
    })

    const onRouteChange = (userPath?: string, organizationPath?: string) => {
        switch (role) {
            case RoleType.USER:
                navigate(userPath!)
                window.scrollTo(0, 0)
                break
            case RoleType.ORGANIZATION:
                navigate(organizationPath!)
                window.scrollTo(0, 0)
                break
            default:
                break
        }
    }

    const onGoPremiumScreenNavigation = () => {
        navigate(`/go-premium/${id}`)
        window.scrollTo(0, 0)
    }

    return (
        <div className="header__profile-item" ref={profieMenuRef}>
            {role === RoleType.USER && (
                <>
                <TutorialBubble text={translation.tutorial_user_profile} placement="left" visible={userDataState.tutorial_progress === 4} hasNext={true} />
                <TutorialBubble text={translation.tutorial_user_chat} placement="left" visible={userDataState.tutorial_progress === 5} hasNext={true} />
                                <div className="header__menu-profile" data-tutorial-anchor="header-profile-menu" onClick={() => setProfileMenuOpen(!profileMenuOpen)}>
                    <Image className="header__image" src={userDataState.profile_photo?.url_path || profileDefault} alt="profile" />
                    <GreyVectorDown />
                </div>
                </>
            )}

            

            {role === RoleType.ORGANIZATION && (
                <>
                    <TutorialBubble text={translation.tutorial_org_profile} placement="left" visible={organizationDataState.tutorial_progress === 7} hasNext={true} routeOnNext={`/organization-profile/${organizationDataState.id}`} />
                    <div className="header__menu-profile" data-tutorial-anchor="header-profile-menu" onClick={() => setProfileMenuOpen(!profileMenuOpen)}>

                    <Image className="header__image" src={organizationDataState?.photo?.url_path || organizationProfileDefault} alt="profile" />
                    <GreyVectorDown />

                </div>
                </>
            )}

            {profileMenuOpen && (
                <div className="header-profile-menu">
                    <Card>
                        <div className="header-profile-menu__card">
                            {role === RoleType.USER && (
                                <div onClick={() => onRouteChange("/user-profile", "")} className="header-profile-menu__profile">
                                    <div className="header-profile-menu__image">
                                        <Image
                                            className="image image__profile image__profile--size-medium "
                                            src={userDataState.profile_photo?.url_path || profileDefault}
                                        />
                                    </div>
                                    <div className="header-profile-menu__profile-text-container">
                                        <div className="header-profile-menu__profile-text"> {userDataState.first_name + " " + userDataState.last_name} </div>
                                    </div>
                                </div>
                            )}
                            {role === RoleType.ORGANIZATION && (
                                <div
                                    onClick={() => onRouteChange("", `/organization-profile/${organizationDataState.id}`)}
                                    className="header-profile-menu__profile"
                                >
                                    <div className="header-profile-menu__image">
                                        <Image
                                            className="image image__profile image__profile--size-medium "
                                            src={organizationDataState?.photo?.url_path || organizationProfileDefault}
                                        />
                                    </div>
                                    <div className="header-profile-menu__profile-text-container">
                                        <div className="header-profile-menu__profile-text"> {organizationDataState?.name} </div>
                                    </div>
                                </div>
                            )}

                            {role === RoleType.USER && (
                                <HeaderMenuItem
                                    onClick={onUserSettingsModalOpen}
                                    title={translation.settings}
                                    className="header-profile-menu__item header-profile-menu__item--border-bottom-3"
                                />
                            )}
                            {role === RoleType.ORGANIZATION && (
                                <>
                                    <HeaderMenuItem
                                        onClick={onOrganizationSettingsModalOpen}
                                        title={translation.manageProfile || "Profil verwalten"}
                                        className="header-profile-menu__item header-profile-menu__item--border-bottom-3"
                                    />
                                    <HeaderMenuItem
                                        onClick={onManageAdmins}
                                        title={translation.manageAdmins || "Admins verwalten"}
                                        className="header-profile-menu__item header-profile-menu__item--border-bottom-3"
                                    />
                                    <HeaderMenuItem
                                        onClick={onCreateRoom}
                                        title={translation.CreateRoom || "Raum anlegen"}
                                        className="header-profile-menu__item header-profile-menu__item--border-bottom-3"
                                    />
                                </>
                            )}

                            {role === RoleType.USER && (
                                <HeaderMenuItem
                                    onClick={onAddOrganizationModalOpen}
                                    title={translation.addOrganization}
                                    className="header-profile-menu__item header-profile-menu__item--border-bottom-3"
                                />
                            )}

                            <a
                                href="https://edusiia.com/faq/"
                                target="_blank"
                                rel="noreferrer"
                                className="header-profile-menu__item header-profile-menu__item--border-bottom-3"
                            >
                                {" "}
                                {translation.fAQ}
                            </a>

                            <HeaderMenuItem
                                onClick={logOut}
                                title={translation.logOut}
                                className="header-profile-menu__item header-profile-menu__item--hover-color-red header-profile-menu__item--text-color-white"
                            />
                        </div>
                    </Card>
                </div>
            )}{" "}
        </div>
    )
}

export default HeaderProfileMenu
